import { GameState, BuffState } from '../core/GameState';
import { eventBus } from '../core/EventBus';
import { BUFF_TYPES, BuffTypeDef } from '../data/buffs';

export class BuffSystem {
  gain(state: GameState, typeId: string, duration: number): void {
    const typeDef = this.getTypeDef(typeId);
    if (!typeDef) return;

    const existing = state.buffs.get(typeId);
    if (existing) {
      existing.time = Math.max(existing.time, duration);
      return;
    }

    const buff: BuffState = {
      typeId,
      name: typeDef.name,
      maxTime: duration,
      time: duration,
      multCpS: typeDef.multCpS,
      multClick: typeDef.multClick,
      add: typeDef.add,
    };

    state.buffs.set(typeId, buff);
    eventBus.emit('buff:gained', buff);
    eventBus.emit('gains:recalculate');
  }

  update(state: GameState, dtMs: number): void {
    const expired: string[] = [];

    state.buffs.forEach((buff, key) => {
      buff.time -= dtMs / 1000;
      if (buff.time <= 0) {
        expired.push(key);
      }
    });

    for (const key of expired) {
      state.buffs.delete(key);
      eventBus.emit('buff:expired', key);
    }

    if (expired.length > 0) {
      eventBus.emit('gains:recalculate');
    }
  }

  kill(state: GameState, typeId: string): void {
    if (state.buffs.delete(typeId)) {
      eventBus.emit('buff:expired', typeId);
      eventBus.emit('gains:recalculate');
    }
  }

  killAll(state: GameState): void {
    if (state.buffs.size > 0) {
      state.buffs.clear();
      eventBus.emit('gains:recalculate');
    }
  }

  has(state: GameState, typeId: string): boolean {
    return state.buffs.has(typeId);
  }

  getTypeDef(id: string): BuffTypeDef | undefined {
    return BUFF_TYPES.find((t) => t.id === id);
  }
}
